import React from "react";
import PropTypes from "prop-types";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { Button } from "../../../../../../shared/Button/Button";
import { svg } from "../../../../../../assets/svg";
import { DateRangePicker } from "../../../../../../shared/DateRangePicker/DateRangePicker";
import { ReportHeader } from "../../../../components/ReportHeader/ReportHeader";
import { useCurrentUserQuery } from "../../../../../../api/queries/useUserQuery";
import { TotalCount } from "../../../../components/TotalCount/TotalCount";
import { CircularProgress } from "../../../../../../shared/CircularProgress/CircularProgress";
import { composeDownloadDataUrl } from "../../../../../../utilities/api";
import { uiNotification } from "../../../../../../services/UINotificationService";

export function Header({
  isFilterActive,
  onFilterOpen,
  period,
  exportReport,
  isReportsLoading,
  totalCount,
}) {
  const { tBi } = useAppTranslation.BusinessInsights();
  const { tCommon } = useAppTranslation.Common();
  const { data: user } = useCurrentUserQuery();

  const downloadReport = async () => {
    try {
      const res = await exportReport.initiate();
      window.open(composeDownloadDataUrl(res.data.data.file), "_blank");
    } catch (e) {
      uiNotification.error(tCommon("error.exportXlsReports"));
    }
  };

  return (
    <ReportHeader
      label={tBi("servicesPerformedReport.label")}
      left={<TotalCount>{totalCount}</TotalCount>}
    >
      <DateRangePicker
        isDisabled={isReportsLoading}
        size="small"
        dateFormat={user?.dateFormat}
        onChange={({ startDate, endDate }) => {
          period.update({
            from: startDate,
            to: endDate,
          });
        }}
        value={{
          startDate: period.value.from,
          endDate: period.value.to,
        }}
      />
      <Button
        size="small"
        variant="outlined"
        onClick={downloadReport}
        isDisabled={exportReport.exportLoading || isReportsLoading}
        leftAdornment={
          exportReport.exportLoading ? (
            <CircularProgress size="small" />
          ) : (
            <img src={svg.downloadPrimary} alt="dl" width="20px" />
          )
        }
      >
        {tCommon("label.downloadExcel")}
      </Button>
      <Button
        size="small"
        variant="outlined"
        onClick={onFilterOpen}
        isDisabled={isReportsLoading}
        leftAdornment={
          isFilterActive ? (
            <img src={svg.filterPrimaryActive} alt="filter" width="16px" />
          ) : (
            <img src={svg.filterPrimary} alt="filter" width="14px" />
          )
        }
      >
        {tCommon("label.filter")}
      </Button>
    </ReportHeader>
  );
}

Header.propTypes = {
  isFilterActive: PropTypes.bool.isRequired,
  onFilterOpen: PropTypes.func.isRequired,
  period: PropTypes.shape({
    value: PropTypes.shape({
      from: PropTypes.instanceOf(Date),
      to: PropTypes.instanceOf(Date),
    }),
    update: PropTypes.func,
  }).isRequired,
  downloadExcel: PropTypes.shape({
    initiate: PropTypes.func,
    isLoading: PropTypes.bool,
  }).isRequired,
  isReportsLoading: PropTypes.bool.isRequired,
  totalCount: PropTypes.number,
};

Header.defaultProps = {
  totalCount: 0,
};
